import * as React from 'react';

import type { Props as ButtonProps } from 'bundles/authentication/shared/Button';
import Button from 'bundles/authentication/shared/Button';

type Props = Omit<ButtonProps, 'primary' | 'ghost' | 'type'>;

const Submit = ({ secondary = false, ...props }: Props) => (
  <Button {...props} {...(secondary ? { secondary: true } : { primary: true })} type="submit" />
);

export default Submit;
